<template>
  <div class="footer my_footer">
    <div class="container">
      <div class="footer_t">
        <div class="contact-us">
          <div>
            <h5>联系我们</h5>
            <p>北京市海淀区知春路108号豪景大厦B座{{host?'1401':'1405'}}室</p>
            <p>010-82101099</p>
          </div>
        </div>
        <ul @click="jumpPage('/askanswer')">
          <li>
            <p>关于我们</p>
            <span>
              <a>平台介绍</a>
            </span>
            <span>
              <a>加入我们</a>
            </span>
            <span @click.stop="jumpPage('/privacy')">
              <a>用户隐私申明</a>
            </span>
            <span @click.stop="jumpPage('/news')">
              <a>媒体报道</a>
            </span>
          </li>
          <li>
            <p>我是租户</p>
            <span>
              <a>租赁流程</a>
            </span>
            <span>
              <a>租赁保障</a>
            </span>
            <span @click.stop="jumpPage('/rentalAgreement')">
              <a>租赁协议</a>
            </span>
          </li>
          <li>
            <p>我是租赁商</p>
            <span>
              <a>平台介绍</a>
            </span>
            <span>
              <a>加入我们</a>
            </span>
          </li>
        </ul>
      </div>
      <div class="footer_b">
        <p class="banquan" v-if="!host">
          <span>
            <img src="../../static/img/logo.png">
            <span>京ICP备19012330号</span>
          </span>
          <a
            target="_blank"
            class="gov-txt"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802029217"
          >
            <img src="../../static/img/icon_gov.png">
            <span>京公网安备 11010802029217号</span>
          </a>
        </p>
        <p class="banquan">Copyright@2019 {{host?'华视风行集团':'大租行（北京）有限公司'}} 版权所有</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      host:window.location.host.indexOf('zulin')>-1
    }
  },
  methods: {
    jumpPage(url) {
      this.$router.push(url);
    }
  }
};
</script>


<style scoped>
.footer {
  width: 100%;
  padding: 40px 0 20px 0;
  font-size: 12px;
  background: #5e5e5e;
}
.footer_t {
  display: flex;
  justify-content: space-around;
}
.footer_t ul li {
  float: left;
  margin-right: 45px;
  color: #fff;
}
.footer_t ul li span {
  display: block;
}
.footer_t ul li span a {
  color: #fff;
  opacity: 0.65;
}
.footer_t ol li {
  float: left;
  margin-right: 18px;
}
.footer_t ol li img {
  width: 65px;
  height: 65px;
}
.footer_t ol li span {
  text-align: center;
  line-height: 40px;
  display: block;
  color: #fff;
}
.footer_t ol li .logo_pic {
  width: 100px;
  height: auto;
}
.footer_b {
  color: #fff;
  margin-top: 40px;
}
.footer_b ul li {
  float: left;
  margin-right: 40px;
}
.footer_b ul li a {
  color: #fff;
}
.banquan {
  color: #fff;
  text-align: center;
  line-height: 20px;
}
.fixed-b {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
}
.contact-us {
  color: #fff;
  display: flex;
  align-items: center;
}
.contact-us p {
  line-height: 20px;
}
.contact-us h5 {
  font-size: 16px;
}
.logo {
  width: 70px;
  height: 70px;
  margin-right: 20px;
}
.gov-txt,
.gov-txt:hover {
  margin-left: 20px;
  color: #fff;
}
.banquan img {
  width: 20px;
  height: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/footer.vue